import React from "react";
import { RequireRole } from "../../app/router/RequireRole";
import { ProfilePage } from "./pages/ProfilePage";

/**
 * Profile feature routes — available to any authenticated tenant member.
 *   /:slug/app/perfil → ProfilePage (account info + change password)
 */
const profileRoutes = [
  {
    path: "/:slug/app/perfil",
    element: (
      <RequireRole>
        <ProfilePage />
      </RequireRole>
    ),
  },
];

export default profileRoutes;
